import React, { useState } from "react";
import Sidebar from "components/Content/Sidebar/Sidebar";
import Topbar from "components/Content/Topbar/Topbar";
import Footer from "components/Content/Footer/Footer";
import SidebarStyles from "components/Content/Sidebar/Sidebar.module.css";
import { SidebarData } from "./SidebarData";
export default function Layout(props) {
  const toggleClass = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
  };
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [title, setTitle] = useState("");

  const changeTitle = (newTitle) => {
    setTitle(newTitle);
  }

  return (
    <>
      <Sidebar
        toggleHandler={toggleClass}
        changeTitle={changeTitle}
        siderbarClosed={isSidebarExpanded}
        sidebarToggleIcon={isSidebarExpanded}
        logoToggle={isSidebarExpanded}
        rightPanelWidth={isSidebarExpanded}
        data={SidebarData}
      />
      <div
        className={`${SidebarStyles.rightPanel} ${
          !isSidebarExpanded ? SidebarStyles.closedRightPanel : ""
        }`}
      >
        <Topbar title={title}/>
        <main>
          <div className="content-wrapper">
            {props.children}
          </div>
          <Footer />
        </main>
      </div>
    </>
  );
}
